import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Headers, Http, RequestOptions} from '@angular/http';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class PhysicianService {
    readonly baseURL = DDP_ENV.patientUrl;

    constructor(private _http: Http, private cookieService: CookieService) {}

    getAllPhysicians(page, status, size, regEx) {
        console.log('Inside get physician');
        return this._http.get(this.baseURL + '/app/physician' + '?page=' + page + '&status=' + status + '&size=' + size + '&regexPattern=' + regEx  + '&docsAndPictureRequired=false', this.buildHeaders());
    }

    getPhysician(mrn) {
        console.log('Inside get patient details for mrn : ' + mrn);
        return this._http.get(this.baseURL + '/patients/' + mrn, this.buildHeaders());
    }

    getPhysicianQRCode(id) {
        console.log('Inside get qr code details for phy id : ' + id);
        return this._http.get(this.baseURL + '/app/qr/pdf/' + id, this.buildHeaders());
    }

    getPhysicianComment(id) {
        console.log('Inside get patient details for mrn : ' + id);
        return this._http.get(this.baseURL + '/app/physician/review/physician/' + id, this.buildHeaders());
    }

    getPhysicianUnpublishedComment(status,page, size) {
        console.log('Inside get physician unpublished comment : ');
        return this._http.get(this.baseURL + '/app/physician/review/all?status='+status+'&page='+page+'&size='+size, this.buildHeaders());
    }

    publishPhysicianComment(id) {
        console.log('Inside get patient details for mrn : ' + id);
        return this._http.put(this.baseURL + '/app/physician/review/' + id + '/publish', '',this.buildHeaders());
    }

    getPhysicianById(id) {
        console.log('Inside get physician details for id : ' + id);
        return this._http.get(this.baseURL + '/app/physician/' + id, this.buildHeaders());
    }

    updatePhysicianStatus(body) {
        return this._http.put(this.baseURL + '/app/physician/modify/status/change', body , this.buildHeaders());
    }

    /* Construct a common header */
    private buildHeaders(): any {
        const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
        return new RequestOptions({ headers: headers });
    }
}
